import { Routes } from '@angular/router';
import { authGuard } from './auth.guard';
import { AddQuestionComponent } from './pages/questions/add-question/add-question.component';
import { UploadComponent } from './pages/upload/upload.component';
import { AuthenticationComponent } from './layout/authentication/authentication.component';
import { MainComponent } from './layout/main/main.component';
import { MeetingsComponent } from './pages/meetings/meetings.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { OpportunityDetailComponent } from './pages/dashboard/opportunity/opportunity-detail/opportunity-detail.component';
import { OptionsComponent } from './pages/settings/options/options.component';

export const routes: Routes = [{
  path: '',
  component: MainComponent,
  children: [
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    {
      path: 'dashboard',
      component: DashboardComponent,
      canActivate: [authGuard],
    },
    {
      path: 'opportunity-detail/:opportunityId/:botId',
      component: OpportunityDetailComponent,
      canActivate: [authGuard],
    },
    {
      path: 'add-question',
      component: AddQuestionComponent,
      canActivate: [authGuard],
    },
    {
      path: 'upload',
      component: UploadComponent,
      canActivate: [authGuard],
    },
    {
      path: 'meetings',
      component: MeetingsComponent,
      canActivate: [authGuard],
    },
    {
      path: 'settings',
      component: OptionsComponent,
      canActivate: [authGuard],
    },
  ]
}, {
  path: '',
  component: AuthenticationComponent,
  children: [{
    path: '',
    loadChildren: () =>
      import('./pages/authorization/authorization.module').then(
        (m) => m.AuthorizationModule
      ),
  },]
}, {
  path: '**',
  redirectTo: 'modules/pages/miscellaneous/error' // Error 404 - Page not found
}];
